import React from 'react';
import {Button, Input} from 'reactstrap'
import AbstractField from "./AbstractField";
import {mergeAddons} from "./../utils";
import Icon from "./../icon/FAIcon";

function debounce(func, wait, immediate) {
    if (!wait) return func;

    var timeout;

    return function() {
        var context = this, args = arguments;

        var later = function() {
            timeout = null;

            if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
    };
}

/**
 * Hledací field, který posílá hledaný text se spožděním, když uživatel nic nepíše nebo jen při stusku enter nebo hledacího tlačítka.
 */
class SearchField extends AbstractField {
    static PropTypes = {
        debounceTime: React.PropTypes.number,
        searchOnChange: React.PropTypes.bool,    // pokud je true, hledá se hned při psaní se spožděním debounceTime, pokud je false, hledá se při stisku hledat nebo enter
        customButton: React.PropTypes.node
    };

    static defaultProps = {
        debounceTime: 250,
        searchOnChange: false
    };

    constructor(props) {
        super(props);

        this.doSearch = debounce((text, onSearch) => {
            onSearch(text);
        }, props.debounceTime);

        this.state = {
            searchText: props.value
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
            this.setState({
                searchText: nextProps.value
            })
        }
    }

    handleSearchChange = (e) => {
        const {searchOnChange, onChange} = this.props;
        const value = e.target.value;
        this.setState({
            searchText: value
        });
        if (searchOnChange) {
            this.doSearch(value, onChange);
        }
    };

    handleSearch = () => {
        const {onChange} = this.props;
        const {searchText} = this.state;
        onChange(searchText);
    };

    handleKeyDown = (e) => {
        if(e.keyCode == 13) {
            e.preventDefault();
            e.stopPropagation();
            this.handleSearch();
        }
    };

    render() {
        const {debounceTime, searchOnChange, disabled, addonsAfter, onChange, value, customButton, addonsBefore, ...props} = this.props;
        const {searchText} = this.state;

        // const wrapperClassNames = classNames(
        //     className,
        //     "search-field-container",
        // );

        const button = customButton ? customButton :
            <Button disabled={disabled}
                    onClick={this.handleSearch}
                    type="button">
                <Icon icon='search'/>
            </Button>;

        const searchAddons = <div key="searchAddons" className="input-group-btn">{button}</div>

        const field = (
            <Input
                type="text"
                disabled={disabled}
                {...props}
                onKeyDown={this.handleKeyDown}
                value={searchText}
                onChange={this.handleSearchChange}
            />
        );

        return this.renderFieldWithAddons(field, addonsBefore, mergeAddons(addonsAfter, searchAddons));
    }
}
export default SearchField;
